import { GetGloabalSearchIsoMaterialList, GetGloabalSearchIsoWeldLogList, GetGloabalSearchMachineCertificationList, GetGloabalSearchWeldingGasList, GetGloabalSearchWeldingOperatorsList } from "../../redux/action/GloabalsearchAction/GlobalSearchAction";

export const ImageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

export const donutChartData = {
  projects: {
    series: [62, 81, 22],
    options: ["Assigned", "Ongoing", "Completed"],
  },
  inspectorData: {
    series: [80, 80],
    options: ["Active Inspector", "Inactive Inspector"],
  },
};

export const heading = [
  { name: "S No.", sortable: false },
  { name: "ID", field: "employee_id", sortable: true },
  { name: "User Name", field: "inspector_name", sortable: true },
  { name: "User Role", field: "user_type",  sortable: false },
  { name: "Mobile Number", field: "mobile_number" },
  { name: "Email Address", field: "email" },
  { name: "Status", field: "user_status", sortable: true },
  { name: "Last Modified", field: "updatedAt", sortable: true },
  { name: "Action", sortable: false },
];

export const heading1 = [
  { name: "S No." },
  { name: "ID" },
  { name: "Project Name" },
  { name: "Inspector Assigned" },
  { name: "Status" },
  { name: "Last Modified" },
  { name: "Action" },
];

export const AssignHeading = [
  { name: "S No." },
  { name: "Project ID" },
  { name: "Project Name" },
  { name: "Status" },
  { name: "Assigned Date" },
  // { name: "Time" },
  { name: "" },
];

export const breadcrumbNameMap = {
  "manage-inspector": "User Management",
  "add-inspector": "Add User Management",
  "view-inspector-details": "View User Details",
  "edit-inspector": "Edit  User Details",
  "manage-project": "Manage Project",
  "add-project": "Add Project",
  "view-project-details": "View Project Details",
  "edit-manage-project": "Edit Project Details",
  "add-inspection": "Material Inspection",
  "welding-gas-form": "Welding Gas Certification",
  "welding-machine-calibration": "Machine Certifiaction",
  "welding-wpq-inspection": "Welding Operators or Welder Certifications",
  "iso-weld-log": "Isometric Weld Logs",
  "project-report": "NCR Reports",
  "ncr-report": "Project Reports",
  master: "Master",
  "description-master": "Description Master",
  "size-master": "Size Master",
  "ends-master": "Ends Master",
  "type-master": "Type Master",
  "surface-master": "Surface Master",
  "welding-master": "Welding Master",
  "inspection-loc-master": "Inspection Loc Master",
  "manufacturer-master": "Manufacturer Master",
  "add-description-master": "Add Description Master",
  "add-size-master": "Add Size Master",
  "add-type-master": "Add Type Master",
  "add-ends-master": "Add Ends Master",
  "add-surface-master": "Add Surface Master",
  "add-welding-master": "Add Welding Master",
  "add-inspection-master": "Add Inspection Loc Master",
  "add-manufacturer-master": "Add Manufacturer Master",
  "/data-verification": "Data Verification",
};

export const AssignInspectorData = [
  {
    id: 1,
    name: "Welding Firm",
    idNumber: "1121",
    time: "04:30 PM",
    lastModified: "22/09/2021",
  },
  {
    id: 2,
    name: "Welding Firm",
    idNumber: "1122",
    time: "01:30 PM",
    lastModified: "23/09/2021",
  },
  {
    id: 3,
    name: "Welding Firm",
    idNumber: "1123",
    lastModified: "25/09/2021",
    time: "12:30 PM",
  },
];

export const notifications = [
  {
    id: 1,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 2,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 3,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 4,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 5,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 6,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 7,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 8,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 9,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 10,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 11,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 18,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 19,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 20,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
  {
    id: 21,
    name: "Project has been assigned to you, please read the ...",
    frequency: "60 Hours",
    lastModified: "22/09/2021",
  },
];

export const NotificationHeading = [
  { name: "S No." },
  { name: "Message" },
  { name: "Created At" },
  // { name: "Frequency ID" },
  // { name: "Last Modified" },
  // { name: "Action" },
];

export const DataVerificationHeading = [
  { name: "Form Name" },
  { name: "Drawing Number" },
  { name: "System" },
  { name: "Fied Name" },
  { name: "Exception Data" },
  { name: "Error" },
  { name: "Inspector Name" },
  { name: "Inspection Date" },
  { name: "Modified Date" },
];

export const MasterHeading = [
  { name: "S No." },
  { name: " Name" },
  { name: " Sequence" },
  { name: "Status" },
  { name: "Action" },
];

export const MasterData = [
  {
    id: 1,
    name: "Project has been assigned to you, please read the ...",
    status: "Active",
  },
  {
    id: 2,
    name: "Project has been assigned to you, please read the ...",
    status: "Blocked",
  },
  {
    id: 3,
    name: "Project has been assigned to you, please read the ...",
    status: "Blocked",
  },
  {
    id: 4,
    name: "Project has been assigned to you, please read the ...",
    status: "Active",
  },
  {
    id: 5,
    name: "Project has been assigned to you, please read the ...",
    status: "Active",
  },
];

export const dataRows = [
  {
    receiving: "001",
    line: "003",
    description: "24335533",
    size: '2.0"',
    heat: "3",
    tag: "334446",
    inspector: "Raman Singh",
  },
  {
    receiving: "003",
    line: "003",
    description: "24335533",
    size: '2.0"',
    heat: "3",
    tag: "334446",
    inspector: "Raman Singh",
  },
  {
    receiving: "005",
    line: "003",
    description: "24335533",
    size: '2.0"',
    heat: "3",
    tag: "334446",
    inspector: "Raman Singh",
  },
];

export const testData = [
  {
    id: 4,
    name: "Sally",
    salary: "72,400",
    material: "Material 2",
    size: "Size 2",
    heat: "Heat 2",
    tag: "Tag 2",
    menuOpen: false,
  },
  {
    id: 5,
    name: "Akshay",
    salary: "72,400",
    material: "Material 4",
    size: "Size 6",
    heat: "Heat 5",
    tag: "Tag 3",
    menuOpen: false,
  },
];

export const FORM_STATUS_STYLES = {
  0: { label: "Open" },
  1: { label: "Complete" },
  2: { label: "Delete" },
  3: { label: "Issue" },
  4: { label: "Top Ready" },
  5: { label: "Ready" },
};

export const ProjectFormData = [
  {
    name: "Material Inspection",
    value: 2976,
    form_name: "material_inspection",
  },
  {
    name: "Welding Gas Certification",
    value: 291,
    form_name: "welding_gas",
  },
  {
    name: "Machine Certification",
    value: 29,
    form_name: "machine_certification",
  },
  {
    name: "Welding Operators / Welder Certification",
    value: 292,
    form_name: "welder_certification",
  },
  {
    name: "Isometric Weld Logs",
    value: 295,
    form_name: "iso_weldlog",
  },
];

export const errorMessages = {
  is_draw_no_valid:
    "Drawing number should be unique. This number has already been added.",
  is_valid_weld_no:
    "Welding number should be unique. This number has already been added.",
  is_valid_welder_id: "Welder ID not found in the Welder Certification form.",
  is_valid_size: "Welder size not found in the Material Inspection.",
  is_valid_description:
    "Material description not found in the Material Inspection.",
  is_valid_description1:
    "Material description not found in the Material Inspection.",
  is_valid_heat1: "Heat number not found in the Material Inspection.",
  is_valid_serial1: "Serial number not found in the Material Inspection.",
  is_valid_serial2: "Serial number not found in the Material Inspection.",
  is_valid_heat2: "Heat number not found in the Material Inspection.",
  is_valid_machine_id: "Machine ID not found in the Machine Certification.",
  is_valid_gas_id: "Gas ID not found in the Welding Gas Certification.",
};

export const ISO_Weld_log_Form_Table_Header = [
  "Welding Location",
  "Welding Number",
  "Weld Date",
  "Welder ID",
  "Weld Size",
  "MTR ID 1",
  "Material Description 1",
  "Heat Number 1",
  "Serial Number 1",
  "MTR ID 2",
  "Material Description 2",
  "Heat Number 2",
  "Serial Number 2",
  "Machine ID",
  "Gas ID",
  "Inspection Date",
  "Inspector",
  "Inspection Type",
  "Inspection Result",
  "Weld Defect",
  "Menu Weld",
  // "Inspector Name",
  "Welder Additional Info",
  "Other Inspection Type",
  "Additional Comment",
  "",
];

export const ISO_Weld_log_Form_Non_Welded_Table_Header = [
  "Size",
  "Material Description 1",
  "Doc ID",
  "Heat Number 1",
  "Serial Number 1",
  "",
];

export const Dashboard_Statics_Table_Header = [
  "Form Name",
  "Total Filled Form",
  "Total Error in Form",
  "Total Error in Fields",
];

export const Operator_Summary_Table_Header = [
  "Inspector",
  "Inspector Name",
  "Total Accepted",
  "Total Rejected",
  "Total Welds",
  "ID INSP Total",
  "ID INSP Rate",
  "Accepted Streak",
  "Other Inspection Type",
  "Rejection Ratio",
];

export const Welder_Summary_Table_Header = [
  "Welder",
  "Welder Name",
  "Total Accepted",
  "Total Rejected",
  "Total Welds",
  "ID INSP Total",
  "ID INSP Rate",
  "Accepted Streak",
  "Other Inspection Type",
  "Rejection Ratio",
];

export const statusOptions = [
  { id: "0", label: "Open" },
  { id: "1", label: "Complete" },
  { id: "2", label: "Delete" },
  { id: "3", label: "Issue" },
  { id: "4", label: "Top" },
  { id: "5", label: "Ready" },
];


export const inspectionType = [
    { name: "Material Inspection", id: "mi" },
    { name: "Welding Gas Certification", id: "wgc" },
    { name: "Machine Certification", id: "mac" },
    { name: "Welding Operators / Welder Certification", id: "wowc" },
    { name: "Isometric Weld Logs", id: "iwl" },
  ];

export const apiMapping = {
  mi: GetGloabalSearchIsoMaterialList,
  wgc: GetGloabalSearchWeldingGasList,
  mac: GetGloabalSearchMachineCertificationList,
  wowc: GetGloabalSearchWeldingOperatorsList,
  iwl: GetGloabalSearchIsoWeldLogList,
};

export const selectField = {
    mi: [
      { id: "size_id", name: "Size" },
      { id: "heat", name: "Heat" },
      { id: "classification", name: "Classification" },
      { id: "description_id", name: "Material Description" },
      { id: "tag_id", name: "Tag Number" },
      { id: "serial_no", name: "Serial Number" },
      { id: "manufacturer", name: "Manufacturer" },
    ],
    wgc: [{ id: "lot_number", name: "Serial No./Lot ID" }],
    mac: [{ id: "serial_number", name: "Machine Serial No." }],
    wowc: [
      { id: "name", name: "Name" },
      { id: "welder_id", name: "Welder ID" },
      { id: "cert_id", name: "Cert ID/Type" },
    ],
    iwl: [
      { id: "iso_draw_no", name: "Drawing Number" },
      { id: "p_id", name: "P & ID" },
    ],
  };

export const headerOptions = {
  mi: [
    { label: "Project Name", field: "project_name" },
    { label: "Inspection ID", field: "ref_no" },
    { label: "Receiving #", field: "receiving" },
    { label: "Line #", field: "line" },
    { label: "Material Type", field: "material_type" },
    { label: "Classification", field: "classification" },
    { label: "Material Description", field: "description_id" },
    { label: "Surface Finish", field: "surface_name" },
    { label: "Size", field: "size_id" },
    { label: "Heat1 #", field: "heat" },
    { label: "Tag ID", field: "tag_id" },
    { label: "Inspector Name", field: "inspectors_name" },
    { label: "Creation Date", field: "createdAt" },
    // { label: "Action", field: "document" },
  ],
  wgc: [
    { label: "Project Name", field: "project_name" },
    { label: "Inspection ID", field: "ref_no" },
    { label: "Lot/Serial Number", field: "number" },
    { label: "Location", field: "locName" },
    { label: "Inspection Date", field: "ins_date" },
    { label: "Acceptance Criteria", field: "accept_criteria" },
    { label: "Inspector Name", field: "inspectors_name" },
    { label: "Creation Date", field: "createdAt" },
    // { label: "Action", field: "document" },
  ],
  mac: [
    { label: "Project Name", field: "project_name" },
    { label: "Inspection ID", field: "ref_no" },
    { label: "Weld Serial Number", field: "number" },
    { label: "Location", field: "locName" },
    { label: "Inspection Date", field: "ins_date" },
    { label: "Acceptance Criteria", field: "accept_criteria" },
    { label: "Inspector Name", field: "inspectors_name" },
    { label: "Creation Date", field: "createdAt" },
    // { label: "Action", field: "document" },
  ],
  wowc: [
    { label: "Project Name", field: "project_name" },
    { label: "Inspection ID", field: "ref_no" },
    { label: "Welder ID", field: "number" },
    { label: "Name", field: "name" },
    { label: "Cert ID/Type", field: "cert_id" },
    { label: "Acceptance Criteria", field: "accept_criteria" },
    { label: "Inspector Name", field: "inspectors_name" },
    { label: "Creation Date", field: "createdAt" },
    // { label: "Action", field: "document" },
  ],
  iwl: [
    { label: "Project Name", field: "project_name" },
    { label: "ISO Drawing No.", field: "iso_draw_no" },
    { label: "Inspection ID", field: "ref_no" },
    { label: "System Categoory", field: "system" },
    { label: "Line Class", field: "line_class" },
    { label: "P & ID", field: "p_id" },
    { label: "Inspector Name", field: "inspectors_name" },
    { label: "Creation Date", field: "createdAt" },
    // { label: "Action", field: "document" },
  ],
};
